const REDUCER = "@BLOG/";

const actions = {
  GET_LIST_BLOG: `${REDUCER}GET_LIST_BLOG`,
  SET_LIST_BLOG: `${REDUCER}SET_LIST_BLOG`,
  SET_IS_LOADING: `${REDUCER}SET_IS_LOADING`,
  SET_CURRENT_BLOG: `${REDUCER}SET_CURRENT_BLOG`,
};
export default actions;
